export enum Environment {
    LOCAL = 'local',
    DEVELOPMENT = 'development',
    STAGING = 'staging', 
    PRODUCTION = 'production'
}

export type N3xusApiConfig = {
    apiKey: string
    environment?: Environment
    override?: {
        domain?: string
        endpoint?: string
        version?: string
        env?: string
    }
}

export type N3xusApiSettings = {
    HOST: string
    ENDPOINT: string
    VERSION: string
    ENV?: string
}

export enum MintStatus {
    redeemed = 'REDEEMED',
    available = 'AVAILABLE',
    unavailable = 'UNAVAILABLE',
    minting = 'MINTING',
    error = 'ERROR'
}

export type ClaimStatus = {
    code?: string
    status: MintStatus
    wallet?: string
    available?: null | number 
    campaign?: CampaignStatus | null

}

export type StatusData = {
	ok: boolean
	error?: string
    fetchedAt?: string
	data?: ClaimStatus
}

export type MobilePassData = {
            type: string,
            iPhoneWalletUri: string,
            downloadLink: string,
            androidWalletUri: string,
            isActivated: boolean,
        }

export type AccessCheckData = {
    ok: boolean
    error?: string
    data?: {
        email: string,
        sessionToken: string,
        holds: boolean,
        expired: boolean,
        expiryDate: string,
        mobilePasses?: Array<MobilePassData>
    }
}

export type MintData = {
    issueId: number
    already_minted?: boolean,
    issuanceCode: string | null,
    contract_address: string,
    title: string,
    wallet_address: string,
    estimate_seconds: number,
    message: string,
    message_data: {
        contractAddress: string,
        id: number,
        quantity: number,
        uID: string,
        walletAddresss: string,
        xCallbackUrl: string,
        xRequestId: string
    },
    queue_position: number
}

export type ActivationData = {
    ok: boolean
    error?: string
    data?: {}
}

//TODO: Should we be listing how many 
// are available? I think not should just be true or false as not sure we want this public?
export type CampaignStatusData = {
    ok: boolean
    error: string
    data :{
        available: null | number 
    }
        
}

export type CampaignStatus = {
    id: number,
    name: string,
    contract_address: string,
    start_date: string,
    end_date: string,
    limit: number, //TODO: Again not sure if this should be public
    campaign_url: string,
    used_count: number //TODO: Again not sure if this should be public
}

export type CampaignInformationData = {
    ok: boolean
    error: string
    data: CampaignStatus
}


export type CampaignInformation = {
    id: number,
    name: string,
    contract_address: string,
    start_date: string,
    end_date: string,
    limit: number,
    campaign_url: string,
    used_count: number
}